/**
 * Determines the site type based on the provided URL or the current window location.
 * @returns 'academic' if the domain includes 'academic', 'public' if it includes 'public', otherwise defaults to 'academic'.
 */

export function getSiteType(): 'academic' | 'public' {
  const url = new URL(window.location.href);
  // const url = new URL('https://public.bibliotele.com/');
  // const url = new URL('https://academic.bibliotele.com/');

  const domain = url.hostname.replace(/^www\./, '');
  if (domain.includes('academic')) return 'academic';
  if (domain.includes('public')) return 'public';
  return 'academic';
}
